import { SvgIconTypeMap } from '@mui/material';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction
} from 'react';
import { CustomRouteProps } from 'utils';

export interface SubNavigation {
  title: string;
  iconComponent: OverridableComponent<SvgIconTypeMap<{}, 'svg'>>;
  routeProps: CustomRouteProps;
}

export interface UndoActionState {
  enabled: boolean;
  loading: boolean;
  onClick: (() => void) | null;
}

export interface IPageContext {
  state: {
    title: string | null;
    parentPath: string | null;
    parentTitle: string | null;
    subNavigation: SubNavigation[];
    topBarActions: ReactNode[];
    undoAction: UndoActionState;
  },
  actions: {
    setTitle: Dispatch<SetStateAction<string | null>>;
    setParentPath: Dispatch<SetStateAction<string | null>>;
    setParentTitle: Dispatch<SetStateAction<string | null>>;
    setSubNavigation: Dispatch<SetStateAction<SubNavigation[]>>;
    setTopBarActions: Dispatch<SetStateAction<ReactNode[]>>;
    setUndoAction: Dispatch<SetStateAction<UndoActionState>>;
    setUndoActionOverride: Dispatch<SetStateAction<UndoActionState | null>>;
    clearUndoActionOverride: () => void;
  }
}

const PageContext = createContext<IPageContext | null>(null);

export default PageContext;
